var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:({ backgroundColor: _setup.theme.background }),attrs:{"id":"app"}},[_c(_setup.LandscapeWarning),_c(_setup.Error),_c(_setup.Success),_c(_setup.Loader),_c(_setup.ReLogin),_c(_setup.DDos),_c(_setup.Chat),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }